import type { PlanInterval } from '../types';

export const INTERVAL_LABELS: Record<PlanInterval, string> = {
  month: 'Mensal',
  semester: 'Semestral',
  year: 'Anual',
};

export function formatPlanPrice(price: number, currency: string): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(price / 100);
}
